import { TableSummaryItem } from '../../../../../../generic/grid-table'
import CalendarIcon from '../../../../../../generic/icons/IconLib/CalendarIcon'
import PackageBoxIcon from '../../../../../../generic/icons/IconLib/PackageBoxIcon'
import PalletIcon from '../../../../../../generic/icons/IconLib/PalletIcon'
import ScaleIcon from '../../../../../../generic/icons/IconLib/ScaleIcon'
import ShekelIcon from '../../../../../../generic/icons/IconLib/ShekelIcon'
import { Q4SummaryValues } from '../types/row'

const ICON_SIZE = 14

export const buildQ4SummaryItems = (values: Q4SummaryValues): TableSummaryItem[] => [
  {
    key: 'dateRange',
    label: 'תאריכים',
    value: values.dateRange || '—',
    icon: <CalendarIcon size={ICON_SIZE} />,
  },
  { key: 'revenue', label: 'פדיון', value: values.revenue, icon: <ShekelIcon size={ICON_SIZE} /> },
  { key: 'middlePrice', label: 'מחיר ממוצע', value: values.middlePrice, icon: <ShekelIcon size={ICON_SIZE} /> },
  { key: 'amountPallets', label: 'משטחים', value: values.amountPallets, icon: <PalletIcon size={ICON_SIZE} /> },
  { key: 'weight', label: 'משקל', value: values.weight, icon: <ScaleIcon size={ICON_SIZE} /> },
  { key: 'amountPack', label: 'אריזות', value: values.amountPack, icon: <PackageBoxIcon size={ICON_SIZE} /> },
]
